import React from 'react'
import PropTypes from 'prop-types'

import Card from './components/Card'
import {
  Wrapper,
  Container,
  Title,
  Description,
  CardsContainer,
} from './styles'

export const BGutHealth = ({ texts }) => {
  const { title, description, cards } = texts

  return (
    <Wrapper>
      <Container>
        <Title
          weight={'medium'}
          size={['50/60', '50/60', '35/40']}
          dangerouslySetInnerHTML={{ __html: title }}
        />

        <Description
          size={['22/30', '22/30', '16/25']}
          dangerouslySetInnerHTML={{ __html: description }}
        />

        <CardsContainer>
          {cards.map((card, index) => (
            <Card
              key={index}
              number={index + 1}
              title={card.title}
            />
          ))}
        </CardsContainer>
      </Container>
    </Wrapper>
  )
}

BGutHealth.propTypes = {
  texts: PropTypes.object.isRequired,
}
